import { Injectable, OnDestroy } from '@angular/core'
import { TenantService } from 'framework/tenant/tenant.service'
import { DealConfigurationQuery } from 'generated/graphql'
import { SelectableDealOption } from 'modules/deals/utilities/deal-types'

interface BannerDetails {
    shouldShowContent: boolean
    color: 'purple' | 'black' | 'red' | 'blue' | 'green' | 'blueInfo'
    content: string
}

const AllowedConfigurations: { model: string; edition: string }[] = [{ model: 'Model 3', edition: 'Rear-Wheel Drive' }]
const FiscalValueThreshold = 45000

@Injectable({
    providedIn: 'root',
})
export class SubsidyBannerService implements OnDestroy {
    private tenant: string
    constructor(private tenantService: TenantService) {
        this.tenantService.tenant$.subscribe(tenant => (this.tenant = tenant))
    }
    ngOnDestroy(): void {
        this.tenantService.tenant$.unsubscribe()
    }
    retrieveSubsidyBannerDetails(deal: DealConfigurationQuery['Deal']): BannerDetails {
        const isPrivateLease =
            (
                deal.options.find(
                    opt => opt.__typename === 'SelectableDealOption' && opt.name === 'leasingType'
                ) as SelectableDealOption
            ).selectedValue.id === 'PRIVATE'

        return {
            shouldShowContent:
                this.tenant.includes('nl') &&
                AllowedConfigurations.filter(
                    allowed => allowed.model === deal.modelName && allowed.edition === deal.editionName
                ).length > 0 &&
                isPrivateLease &&
                deal.pricing.fiscalValue > FiscalValueThreshold,
            content:
                '<strong>Let op; de door jouw gemaakte keuze is van invloed op de fiscale waarde van je voertuig. Dit betekent dat je niet meer in aanmerking komt voor de SEPP subsidie (2950 Euro).</strong>',
            color: 'blueInfo',
        }
    }
}
